import { useLocation, useNavigate } from "react-router-dom"
import { Button, MaybeElement } from "@blueprintjs/core"
import { BlueprintIcons_16Id } from "@blueprintjs/icons/lib/esm/generated/16px/blueprint-icons-16"

interface INavButton {
  icon: BlueprintIcons_16Id | MaybeElement
  text: string
  to: {
    pathname: string
  }
  /** An absolute URL outside the app (e.g. the Trade Recon site on
   *  view.scient.io). Opens in a new tab, like a published model page, and
   *  is never shown active: the app's own route never matches it. */
  href?: string
}

const NavButton = ({ icon, text, to, href }: INavButton) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  if (href) {
    return (
      <Button
        onClick={() => window.open(href, "_blank", "noreferrer")}
        icon={icon}
        text={text}
        minimal
      />
    )
  }

  return (
    <Button
      onClick={() => navigate(to.pathname)}
      icon={icon}
      text={text}
      active={pathname.startsWith(to.pathname)}
      minimal
    />
  )
}

export default NavButton
